/** Created by azhou on 2019/3/25.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{Itemize.order_no || Itemize.oid}}</li>
    <li class="w-50 list-item-col" v-if="userInfo.type===2">{{Itemize.order_style | formatVar('OrderStyle')}}</li>
    <li class="w-50 list-item-col" v-else>{{Itemize.comment_time | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col">
      <span class="text-link" @click="GoForDetail">{{isComment ? '去评论':'查看详情'}}</span>
    </li>
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'StoreItemize',
    props:{
      Itemize:{},
      isComment:{}
    },
    computed:{
      ...mapGetters(['userInfo']),
      time() {
        return this.Itemize.comment_time || this.Itemize.deal_time;
      }
    },
    methods:{
      GoForDetail() {
        if (!this.$GFUN.powerIsInArray([259,215,330,405,604])) { this._alert('您没有相关权限！',null,'error'); return; }
        if (!this.isComment) {
          this.$router.push({name:'CommentDetail',query:{commentId:this.Itemize.id,store:this.$route.query.store}})
        } else this.$router.push({name:'CommentPost',query:{orderType:this.Itemize.order_style,orderId:this.Itemize.id,store:this.$route.query.store}})
      }
    }
  }
</script>
